import React from "react";
import Instagram from "../../../../../assets/icons/InstagramSVG.svg";
import Facebook from "../../../../../assets/icons/FacebookSVG.svg";
import Tiktok from "../../../../../assets/icons/tiktokSVG.svg";

import { INVITATION_SOCIALS } from "../../../../../store/services/invitations/dto/invitations.dto";
import { SocialIcon } from "./styles";

const PartnerSocial = ({ social_type }: { social_type: number }) => {
	switch (social_type) {
		case INVITATION_SOCIALS.INSTAGRAM: {
			return <SocialIcon src={Instagram} alt="Instagram icon" />;
		}
		case INVITATION_SOCIALS.FACEBOOK: {
			return <SocialIcon src={Facebook} alt="Facebook icon" />;
		}
		default:
			return <SocialIcon src={Tiktok} alt="Instagram icon" />;
	}
};

export default PartnerSocial;
